module.exports = __webpack_public_path__ + "static/media/bg.48b0129f.jpg";